import assignToThis from '../../helper/assignToThis';
import { ScenarioSizingSeries } from '@/dto/scenario/sizing/ScenarioSizingSeries';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class ScenarioSizingResult {

    public pvCapacity: number[] | null = null;

    public batteryCapacity: number[] | number | null = null;

    public series: ScenarioSizingSeries[] | null = null;

    public pvOptimum: number | null = null;

    public batteryOptimum: number | null = null;

    public batteryAutonomyHour: number | null | undefined = null;

    public constructor(obj: ObjectOnly = {}) {
      assignToThis(this, obj);
    }

}
